import { render, staticRenderFns } from "./TranslationGroup.vue?vue&type=template&id=79e93d22&"
import script from "./TranslationGroup.vue?vue&type=script&lang=js&"
export * from "./TranslationGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports